module.exports = __webpack_public_path__ + "media/images/flags/1x1/cog-a2463038faa5d85013241eee5c8e6e55.svg";